import { useQuery } from '@tanstack/react-query';
import { getClientsMissingRegistrations } from '../requests/communication.request';

export const clientsMissingRegistrationsKey = (monitoringListId?: string) => [
  'clients-missing-registrations',
  monitoringListId ?? 'all'
];

export const useClientsMissingRegistrationsQuery = (monitoringListId?: string) => {
  return useQuery({
    queryKey: clientsMissingRegistrationsKey(monitoringListId),
    queryFn: () => getClientsMissingRegistrations(monitoringListId)
  });
};
